import { ProjectsByStatusLoadParams, projectStatusConfig } from 'entities';

import { ProjectTab } from '..';
import { LoadConfigState } from './types';
import { omitUndefined } from 'utils/object';

export const endpoint = '/projects/status';

const tabToStatus: Record<ProjectTab, string> = {
  Completed: projectStatusConfig.done.code,
  Canceled: projectStatusConfig.canceled.code,
  Unassigned: projectStatusConfig.unassigned.code,
  inProgress: projectStatusConfig.started.code,
};

export const getBaseQuery = (
  tab: ProjectTab,
  { endDate, startDate, ref, team, paginationToken }: LoadConfigState,
): ProjectsByStatusLoadParams => ({
  status: tabToStatus[tab],

  ...(tab !== 'Unassigned'
    ? omitUndefined({
        paginationToken: paginationToken || undefined,
        endDate: endDate ?? undefined,
        startDate: startDate ?? undefined,
        team: team ?? undefined,
        ref,
      })
    : {}),
});
